<template>
  <card id="endDeviceChannels" :title="$t('ed-channels:channels')" no-padding no-footer>
    <template #card-body>
      <div v-if="channels.length === 0" class="p-3 w-100 text-center text-muted font-italic">{{ $t('ed-channels:noChannels') | capitalize }}</div>

      <div v-else class="channel-columns">
        <div v-for="c in channels"
             :key="c.number"
             class="channel px-3 d-flex justify-content-between"
        >
          <span>{{ $t('ed-channels:channel') | capitalize }} {{ c.number }}</span>
          <span>{{ c.frequency }} MHz</span>
        </div>
      </div>
    </template>
  </card>
</template>

<script>
import { isEmpty, orderBy } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'

export default {
  titleKey: 'endDeviceChannels',

  props: {
    devEui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      // Display events
      channels: []
    }
  },

  computed: {
    ...mapGetters(['endDevice'])
  },

  watch: {
    devEui () {
      // Reset data, and get data from new end-device
      this.channels = []
    },

    endDevice () {
      // Do not refresh is we olready have the data
      if (!isEmpty(this.channels)) return

      this.getChannels()
    }
  },

  created () {
    this.getChannels()
  },

  methods: {
    async getChannels (options) {
      if (isEmpty(this.endDevice)) return

      let error, response
      [error, response] = await to(this.$api.getEndDeviceChannels(this.endDevice))
      if (error || !response) return

      this.channels = orderBy(response.data, ['number'], ['asc'])
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .channel-columns {
    column-count: 2;
    column-gap: 0;
    orphans: 1;
    widows: 1;

    @media (min-width: $grid-breakpoint-sm) {
      column-count: 3;
    }
    @media (min-width: $grid-breakpoint-lg) {
      column-count: 4;
    }
    @media (min-width: $grid-breakpoint-xl) {
      column-count: 5;
    }

    .channel {
      display: inline-block;
      line-height: 2rem;
      width: 100%;
      border-right: 1px solid $gray-500;
      margin-right: -1px;
    }
  }
</style>
